/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BankCardChangeReqVo,
  BankCardPageReqVo,
  BankCardVo,
  ResponseBankCardVo,
  ResponsePageDataBankCardVo,
  ResponseString,
} from '../models/index';
import {
    BankCardChangeReqVoFromJSON,
    BankCardChangeReqVoToJSON,
    BankCardPageReqVoFromJSON,
    BankCardPageReqVoToJSON,
    BankCardVoFromJSON,
    BankCardVoToJSON,
    ResponseBankCardVoFromJSON,
    ResponseBankCardVoToJSON,
    ResponsePageDataBankCardVoFromJSON,
    ResponsePageDataBankCardVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
} from '../models/index';

export interface BankCardChangePutRequest {
    bankCardChangeReqVo?: BankCardChangeReqVo;
}

export interface BankCardCreatePostRequest {
    bankCardVo?: BankCardVo;
}

export interface BankCardIdDeleteRequest {
    id: number;
}

export interface BankCardIdGetRequest {
    id: number;
}

export interface BankCardIdPutRequest {
    id: number;
    bankCardVo?: BankCardVo;
}

export interface BankCardPagePostRequest {
    bankCardPageReqVo?: BankCardPageReqVo;
}

export interface BankCardSendVerifyCodeGetRequest {
    userId: number;
}

/**
 * 
 */
export class BankCardControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 银行卡变更（需短信验证码，根据userId+cardType更新卡号/银行名/持卡人姓名）
     */
    async bankCardChangePutRaw(requestParameters: BankCardChangePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bankCard/change`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BankCardChangeReqVoToJSON(requestParameters['bankCardChangeReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 银行卡变更（需短信验证码，根据userId+cardType更新卡号/银行名/持卡人姓名）
     */
    async bankCardChangePut(requestParameters: BankCardChangePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.bankCardChangePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 创建银行卡
     */
    async bankCardCreatePostRaw(requestParameters: BankCardCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bankCard/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BankCardVoToJSON(requestParameters['bankCardVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 创建银行卡
     */
    async bankCardCreatePost(requestParameters: BankCardCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.bankCardCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 删除银行卡
     */
    async bankCardIdDeleteRaw(requestParameters: BankCardIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling bankCardIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bankCard/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 删除银行卡
     */
    async bankCardIdDelete(requestParameters: BankCardIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.bankCardIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取银行卡
     */
    async bankCardIdGetRaw(requestParameters: BankCardIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBankCardVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling bankCardIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bankCard/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBankCardVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取银行卡
     */
    async bankCardIdGet(requestParameters: BankCardIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBankCardVo> {
        const response = await this.bankCardIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新银行卡
     */
    async bankCardIdPutRaw(requestParameters: BankCardIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling bankCardIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bankCard/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BankCardVoToJSON(requestParameters['bankCardVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新银行卡
     */
    async bankCardIdPut(requestParameters: BankCardIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.bankCardIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取马帮通韩国汇款账号
     */
    async bankCardMbtBankAccountGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBankCardVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bankCard/mbtBankAccount`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBankCardVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取马帮通韩国汇款账号
     */
    async bankCardMbtBankAccountGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBankCardVo> {
        const response = await this.bankCardMbtBankAccountGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 银行卡·分页查询
     * 银行卡·分页查询
     */
    async bankCardPagePostRaw(requestParameters: BankCardPagePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataBankCardVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bankCard/page`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BankCardPageReqVoToJSON(requestParameters['bankCardPageReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataBankCardVoFromJSON(jsonValue));
    }

    /**
     * 银行卡·分页查询
     * 银行卡·分页查询
     */
    async bankCardPagePost(requestParameters: BankCardPagePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataBankCardVo> {
        const response = await this.bankCardPagePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 发送银行卡变更验证码
     */
    async bankCardSendVerifyCodeGetRaw(requestParameters: BankCardSendVerifyCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling bankCardSendVerifyCodeGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bankCard/sendVerifyCode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 发送银行卡变更验证码
     */
    async bankCardSendVerifyCodeGet(requestParameters: BankCardSendVerifyCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.bankCardSendVerifyCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
